<div class="install-app">
    <div class="install-center">
        <div class="icon-off">
            <img src="assets/mobile/pwa-install-icon-off.png" alt="">
        </div>
        <button class="app-install-btn" (click)="initInstall()"><span i18n>INSTALL APP</span></button>
        <button class="app-install-version-btn" (click)="userWebVersion()"><span i18n>USE WEB VERSION</span></button>
    </div>
</div>